import { j as t } from "./jsx-runtime-DmTjM30f.mjs";
import { c as l } from "./tw-cn-mXgPecoF.mjs";
import { c as s } from "./index-BpNK5r1N.mjs";
const n = s(["flex flex-col justify-center items-center shrink-0"], {
  variants: {
    type: {
      horizontal: "h-1",
      vertical: "w-1 h-32"
    },
    // TODO: PC 분기 처리가 필요할 경우 pc size 추가 필요
    size: {
      large: "bg-line-neutral-weak1",
      // high
      medium: "bg-line-neutral-weak3",
      small: "bg-line-neutral-weak2",
      // low
      extra_small: "bg-line-neutral-weak1"
      // extra_low
    }
  },
  compoundVariants: [
    {
      type: "horizontal",
      size: "large",
      className: "h-8"
    }
  ],
  defaultVariants: {
    type: "horizontal",
    size: "small"
  }
}), o = ({ type: e = "horizontal", size: a = "small", className: i }) => {
  const r = n({ type: e, size: a });
  return /* @__PURE__ */ t.jsx("div", { className: l(r, i) });
};
o.displayName = "NDS.Divider";
export {
  o as D
};
